export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11147_UNREAD': 'Unread'
};
